import { type UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';

const oidcConfig = {
  authority: import.meta.env.VITE_SSO_HOST,
  client_id: import.meta.env.VITE_SSO_CLIENT_ID,
  redirect_uri: `${window.location.origin}/login/callback`,
  scope: import.meta.env.VITE_AUTH_SCOPE,
  userStore: new WebStorageStateStore({ store: localStorage }),
  stateStore: new WebStorageStateStore({ store: localStorage }),
} satisfies UserManagerSettings;

export default oidcConfig;
